import PropTypes from "prop-types";

const EditHospitalModal = ({
  editHospital,
  setEditHospital,
  handleSaveEditHospital,
  setShowEditHospitalModal,
}) => {
  if (!editHospital) return null;
  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Edit Hospital</h3>
        <div className="form-control">
          <label className="label">Hospital Name (EN)</label>
          <input
            type="text"
            value={editHospital.hospitalNameEN}
            onChange={(e) =>
              setEditHospital({ ...editHospital, hospitalNameEN: e.target.value })
            }
            className="input input-bordered"
          />
        </div>
        <div className="form-control">
          <label className="label">Hospital Name (TH)</label>
          <input
            type="text"
            value={editHospital.hospitalNameTH}
            onChange={(e) =>
              setEditHospital({ ...editHospital, hospitalNameTH: e.target.value })
            }
            className="input input-bordered"
          />
        </div>
        <div className="form-control">
          <label className="label">Hospital Email</label>
          <input
            type="text"
            value={editHospital.hospitalEmail}
            onChange={(e) =>
              setEditHospital({ ...editHospital, hospitalEmail: e.target.value })
            }
            className="input input-bordered"
          />
        </div>
        <div className="form-control mt-2">
          <label className="label cursor-pointer">
            <span className="label-text">Status</span>
            <input
              type="checkbox"
              className="toggle toggle-success"
              checked={editHospital.isActive}
              onChange={(e) =>
                setEditHospital({
                  ...editHospital,
                  isActive: e.target.checked,
                })
              }
            />
          </label>
        </div>
        <div className="modal-action">
          <button className="btn btn-primary" onClick={handleSaveEditHospital}>
            Save
          </button>
          <button className="btn" onClick={() => setShowEditHospitalModal(false)}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
EditHospitalModal.propTypes = {
  editHospital: PropTypes.object,
  setEditHospital: PropTypes.func,
  handleSaveEditHospital: PropTypes.func,
  setShowEditHospitalModal: PropTypes.func,
};

export default EditHospitalModal;